import React from "react";
import { css } from "@mui/system";
import styled from "@emotion/styled";
import { keyframes } from "@emotion/react";

import { rgba } from "polished";

import {
  Box,
  Card as MuiCard,
  CardContent as MuiCardContent,
  Chip as MuiChip,
  Typography as MuiTypography,
} from "@mui/material";
import { spacing } from "@mui/system";
import { useTheme } from "@mui/material/styles";
import sparkleNoise from "../../../vendor/icons/sparkle-noise";

const twinkle = keyframes`
  0% { opacity: 0.2; transform: scale(1); }
  50% { opacity: 0.5; transform: scale(1.05); }
  100% { opacity: 0.2; transform: scale(1); }
`;

const Typography = styled(MuiTypography)(spacing);

const Stats = ({ title, amount, chip, percentagetext, percentagecolor, illustration, bgColor }) => {
  const theme = useTheme();
  console.log(theme, "themethemetheme");
  const Card = styled(MuiCard)`
    position: relative;
    margin-bottom: ${theme.spacing(6)};
    border-radius: 20px;
    box-shadow: ${({ bgColor }) =>
      bgColor
        ? `0 10px 40px -10px ${rgba(bgColor.match(/#[a-fA-F0-9]{3,6}/)?.[0] || "#000", 0.5)}`
        : "0 8px 32px 0 rgba(31, 38, 135, 0.15)"};
    min-height: 140px;
    display: flex;
    flex-direction: column;
    border: none;

    &:hover {
      transform: translateY(-8px);
      box-shadow: ${({ bgColor }) =>
        bgColor
          ? `0 20px 50px -12px ${rgba(bgColor.match(/#[a-fA-F0-9]{3,6}/)?.[0] || "#000", 0.6)}`
          : "0 12px 48px 0 rgba(31, 38, 135, 0.25)"};
    }

    ${(props) =>
      props.illustration &&
      theme.palette.mode !== "dark" &&
      css`
        background: ${rgba(theme.palette.primary.main, 0.125)};
        color: ${theme.palette.primary.main};
      `}
  `;
  const IllustrationImage = styled.img`
    height: 85px;
    width: auto;
    object-fit: contain;
    opacity: 0.9;
    filter: drop-shadow(0 8px 16px rgba(0, 0, 0, 0.2));
  `;
  const CardContent = styled(MuiCardContent)`
    position: relative;
    background: ${({ bgColor }) => bgColor || "linear-gradient(135deg, #607d8b 0%, #455a64 100%)"};
    color: #fff;
    padding: ${theme.spacing(4, 5)} !important;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;

    &::before {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      opacity: 0.4;
      pointer-events: none;
      background-image: url("${sparkleNoise}"),
        radial-gradient(circle at 20% 30%, #fff 1.5px, transparent 0),
        radial-gradient(circle at 70% 60%, #fff 1.5px, transparent 0),
        radial-gradient(circle at 40% 80%, #fff 1.5px, transparent 0),
        radial-gradient(circle at 80% 20%, #fff 1.5px, transparent 0),
        radial-gradient(circle at 30% 50%, #fff 1.5px, transparent 0);
      background-size:
        200px 200px,
        100px 100px,
        150px 150px,
        120px 120px,
        80px 80px,
        90px 90px;
      mix-blend-mode: screen;
      animation: ${twinkle} 5s ease-in-out infinite;
      z-index: 1;
    }

    &::after {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: linear-gradient(135deg, rgba(255, 255, 255, 0.15) 0%, rgba(255, 255, 255, 0) 50%);
      pointer-events: none;
    }
  `;
  return (
    <Card illustration={illustration} bgColor={bgColor}>
      <CardContent bgColor={bgColor}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            width: "100%",
            gap: 2,
            position: "relative",
            zIndex: 2,
          }}
        >
          <Box sx={{ flex: 1, minWidth: 0 }}>
            <Typography
              variant="h6"
              mb={1}
              sx={{
                fontWeight: 600,
                opacity: 0.85,
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                height: "1.5rem", // Standardize title height
                display: "flex",
                alignItems: "center",
              }}
            >
              {title}
            </Typography>
            <Typography
              variant="h2"
              mb={0}
              sx={{
                fontWeight: 800,
                letterSpacing: "-0.02em",
                fontSize: "1.75rem",
                lineHeight: 1.2,
              }}
            >
              {amount}
            </Typography>
          </Box>
          {!!illustration && (
            <Box
              sx={{
                flexShrink: 0,
                ml: "auto",
                width: "85px", // Standardize logo container width
                height: "85px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                p: 2, // Consistency padding
              }}
            >
              <IllustrationImage
                src={illustration}
                alt="Illustration"
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "contain",
                }}
              />
            </Box>
          )}
        </Box>
      </CardContent>
    </Card>
  );
};

export default Stats;
